import { Container, Row, Col } from 'reactstrap';
import { useSelector } from 'react-redux';
import ReferrerListTable from './ReferrerListTable';
import ReferrerListFilter from './Filter/ReferrerListFilter';

const ReferrerListContain = () => {
	const cards = useSelector(state => state.historyUserReferralCompact.data.data)

	return (
		<Container fluid={true}>
			<Row className='learning-block'>
				<Col xl="9" className='xl-80'>
					<Row>
						<ReferrerListTable />
					</Row>
				</Col>
				{cards && (
					<ReferrerListFilter />
				)}
			</Row>
		</Container>
	);
}
export default ReferrerListContain;